import { CHARACTER_CLIPS } from '../data/characterClips'

export const CHARACTER_NAMES = Object.keys(CHARACTER_CLIPS)

export const normalizeCharacterKey = (key) => {
  if (key === 'both' || key === 'song' || key === 'sakira') return key
  return 'sakira'
}

export const characterWantsSlot = (slotName, characterKey) =>
  characterKey === 'both' || characterKey === slotName

export const slotReadyFor = (slot, key) => {
  if (!slot?.root || !slot.machine) return false
  if (key === 'both') return slot.machine.has('idleDuo')
  return slot.machine.has('idleSolo')
}
